import { render, staticRenderFns } from "./PurchaseCoin.vue?vue&type=template&id=093204ae&scoped=true&"
import script from "./PurchaseCoin.vue?vue&type=script&lang=ts&"
export * from "./PurchaseCoin.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseCoin.vue?vue&type=style&index=0&id=093204ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093204ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
